/**
 * @generated SignedSource<<a6ecbbfb3b06bdf07cc62d054dbe93ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGuestBuyerQueryRenderer_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptionsQueryRenderer_item" | "CheckoutMobilePageHeader_item" | "useBuyerFetchHandler_item">;
  readonly " $fragmentType": "CheckoutGuestBuyerQueryRenderer_item";
};
export type CheckoutGuestBuyerQueryRenderer_item$key = {
  readonly " $data"?: CheckoutGuestBuyerQueryRenderer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGuestBuyerQueryRenderer_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGuestBuyerQueryRenderer_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptionsQueryRenderer_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobilePageHeader_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuyerFetchHandler_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f022fbfdce0ebd731f934f2fbdea6aac";

export default node;
